import styled from 'styled-components';

export const ActionButtonsContainer = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
